module.exports = __webpack_public_path__ + "img/couples-046.c40be3b6.jpg";